export default __webpack_public_path__ + "static/media/2.00c1e858.png";